import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AppConsts } from '../../AppConsts';
import { ExternalSystemDto, ExternalSystemService } from 'src/app/proxy/external-systems';

@Component({
  selector: 'app-external-system-selector',
  standalone: false,
  templateUrl: './external-system-selector.component.html',
})
export class ExternalSystemSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() externalSystemsIdSelected: number;
  @Input() isDisabled = false;

  @Output() changeSelectedExternalSystem = new EventEmitter<ExternalSystemDto>();
  externalSystems: ExternalSystemDto[];
  selectedExternalSystem: ExternalSystemDto;

  constructor(
    injector: Injector,
    private readonly _externalSystemService: ExternalSystemService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadExternalSystems();
    this.onSelected();
  }

  async loadExternalSystems(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._externalSystemService.getAllByInput({
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      }));

      this.externalSystems = result.items;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedExternalSystem.emit(this.selectedExternalSystem);
  }

  async setSelecteExternalSystemById(externalSystemId: number): Promise<void> {
    if (!externalSystemId) {
      return;
    }

    this.externalSystemsIdSelected = externalSystemId;

    if (this.isNullOrUndefined(this.externalSystems)) {
      await this.loadExternalSystems();
    }
    
    this.setSelectedExternalSystem();
  }

  private setSelectedExternalSystem(): void {
    if (this.externalSystems?.length && !this.isNullOrUndefined(this.externalSystemsIdSelected)) {
      this.selectedExternalSystem = this.externalSystems.find(x => x.id === this.externalSystemsIdSelected);
      this.onSelected();
    }
  }
}